export default { sha: '2fdffc4017ba0f73ff4fda942e3657161e98475c', buildNumber: 'undefined' }
